import { defineStore } from "pinia";
import axios from "axios";


export const useTicketStore = defineStore("ticket", {
    state: () => {
        return {
            datas: [],
            groupDatas: [],
            messageDatas: [],
            loadings: false
        };
    },

    getters: {
        data: (state) => state.datas,
        groupData: (state) => state.groupDatas,
        messageData: (state) => state.messageDatas,
        loading: (state) => state.loadings,
    },

    actions: {
        get(seen) {
            this.loadings = true;
            const config = {
                method: "get",
                url: useRuntimeConfig().public.apiBase + 'ticket',
                params:{
                },
                headers: {
                    usertoken: localStorage.token,
                },
            };
            if (typeof seen != "undefined") {
                config.params.seen = seen
            }
            return new Promise((resolve, reject) => {
                axios(config)
                    .then((res) => {
                        this.loadings = false
                        this.datas = res.data.data.ticket
                        resolve(res);
                    })
                    .catch((error) => {
                        if (error.response.status == 402)
                            localStorage.clear()
                        this.loadings = false
                        reject(error.response.data);
                    });
            });
        },
        getMsg(id) {
            this.messageDatas = []
            this.loadings = true;
            const config = {
                method: "get",
                url: useRuntimeConfig().public.apiBase + 'ticket/messages',
                headers: {
                    usertoken: localStorage.token,
                },
                params: {
                    ticketid: id
                }
            };
            return new Promise((resolve, reject) => {
                axios(config)
                    .then((res) => {
                        this.loadings = false
                        this.messageDatas = res.data.data.messages
                        resolve(res);
                    })
                    .catch((error) => {
                        if (error.response.status == 402)
                            localStorage.clear()
                        this.loadings = false
                        reject(error.response.data);
                    });
            });
        },
        getGroup() {
            this.loadings = true;
            const config = {
                method: "get",
                url: useRuntimeConfig().public.apiBase + 'ticket/groups',
                headers: {
                    usertoken: localStorage.token,
                },

            };
            return new Promise((resolve, reject) => {
                axios(config)
                    .then((res) => {
                        this.loadings = false
                        this.groupDatas = res.data.data.group
                        resolve(res);
                    })
                    .catch((error) => {
                        if (error.response.status == 402)
                            localStorage.clear()
                        this.loadings = false
                        reject(error.response.data);
                    });
            });
        },
        create(data) {
            this.loadings = true;
            const config = {
                method: "post",
                url: useRuntimeConfig().public.apiBase + 'ticket/create',
                headers: {
                    usertoken: localStorage.token,
                },
                data: {
                    ...data
                }
            };
            return new Promise((resolve, reject) => {
                axios(config)
                    .then((res) => {
                        this.loadings = false
                        resolve(res);
                    })
                    .catch((error) => {
                        if (error.response.status == 402)
                            localStorage.clear()
                        this.loadings = false
                        reject(error.response.data);
                    });
            });
        },
        sendMsg(data) {
            this.loadings = true;
            const config = {
                method: "post",
                url: useRuntimeConfig().public.apiBase + 'ticket/messages/send',
                headers: {
                    usertoken: localStorage.token,
                },
                data: {
                    ...data
                }
            };
            return new Promise((resolve, reject) => {
                axios(config)
                    .then((res) => {
                        this.loadings = false
                        resolve(res);
                    })
                    .catch((error) => {
                        if (error.response.status == 402)
                            localStorage.clear()
                        this.loadings = false
                        reject(error.response.data);
                    });
            });
        },
    },
});